<template>
  <div class="write-panel-container">
    <div v-if="!isMob" class="cover-wrapper">
      <div
        ref="coverImageRef"
        :class="{
          'cover-image': true,
          'enter-in': true,
          'leave-out': setCoverImageFlag,
        }"
        :style="{
          backgroundImage: 'url(' + coverImage + ')',
        }"
      >
      </div>
    </div>
    <div v-if="!uploadingFlag" class="write-panel-wrapper fly-in-1">
      <div class="write-panel">
        <div class="input-wrapper height-1">
          <input type="text" v-model="mailData.name" placeholder="*輸入暱稱（必填）" autofocus>
        </div>
        <div class="input-wrapper height-1">
          <input type="text" v-model="mailData.job" placeholder="當時你的職業／身份是...">
        </div>
        <div class="input-wrapper height-2">
          <textarea
            name="mail-body"
            v-model="mailData.body"
            placeholder="*我的921記憶:（必填，不支援表情符號）"
            :style="{
              backgroundColor: textAreaBackgroundColor,
            }"
          ></textarea>
          <div class="color-selector-wrapper">
            <div v-if="!isMob">更換信紙</div>
            <div
              :class="{
                'color-selector white': true,
                'active': mailData.color === 1,
              }"
              @click="selectColor(1)"
            ></div>
            <div
              :class="{
                'color-selector red': true,
                'active': mailData.color === 2,
              }"
              @click="selectColor(2)"
            ></div>
            <div
              :class="{
                'color-selector yellow': true,
                'active': mailData.color === 3,
              }"
              @click="selectColor(3)"
            ></div>
          </div>
        </div>
      </div>
      <div class="button-and-rights-wrapper">
        <div class="submit-button-wrapper fly-in-2">
          <button
            :class="{
              'submit-button': true,
            }"
            name="submit-button"
            @click="hintNecessaryItem"
          >
            <img src="images/elev.svg" alt="mail">
            寄出
          </button>
        </div>        
        <div class="rights-wrapper fly-in-3">
          編按：此平台收納的921回憶內容非聯合報系提供，相關權利為內容提供者所有，平台不擔保其真實性、正確性、即時性、完整性或合法性。但本平台保留刪除爭議內容的權利。
        </div>
      </div>
      <div v-if="hintMessageFlag" class="hint-message-wrapper">
        <div class="hint-message message-type-1">
          {{hintMessage}}
          <div class="hint-button-wrapper">
            <button name="hint-button" class="hint-button button-type-1" @click="hintMessageFlag = false">關閉</button>
          </div>
        </div>
      </div>
      <div v-if="submitMessageFlag" class="hint-message-wrapper">
        <div class="hint-message message-type-2">
          是否要寄出？寄出後即無法修改文字。
          <div class="hint-button-wrapper">
            <button name="hint-button" class="hint-button button-type-1" @click="submitMail">是</button>
            <button name="hint-button" class="hint-button button-type-2" @click="submitMessageFlag = false">否</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="uploadingFlag" class="uploading-wrapper">
      <img src="images/loading.gif" alt="papercrane">
      <div class="uploading-bar-wrapper">
        <div class="uploading-bar"></div>
      </div>
      <div class="uploading-text">寄信中</div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';

export default {
  name: 'WriteMail',
  data() {
    return {
      mailData: {
        name: '',
        body: '',
        job: '',
        color: 1,
      },
      limitNameLength: 16,
      limitJobLength: 24,
      currentStep: 1,
      hintMessage: '',
      setCoverImageFlag: false,
      addBeforUnloadFlag: false,
      hintMessageFlag: false,
      submitMessageFlag: false,
      uploadingFlag: false,
      nameWordLengthLegalFlag: true,
      jobWordLengthLegalFlag: true,
    };
  },
  watch: {
    mailData:  {
      handler(value) {
        if (value.name !== '' || value.body !== '' || value.job !== '') {
          if (!this.addBeforUnloadFlag) {
            this.createBeforeUnloadHandler();
            this.addBeforUnloadFlag = true;
          }
          if (value.name !== '') {
            this.calcWordLength(value.name, 'name');
          }
          if (value.job !== '') {
            this.calcWordLength(value.job, 'job');
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    isMob() {
      return window.innerWidth < 1024 ? true : false;
    },
    coverImage() {
      if (this.currentStep === 2) {
        this.setCoverImageFlag = true;
      }
      return 'images/write_cover' + this.currentStep + '.jpg';
    },
    textAreaBackgroundColor() {
      const colorSet = {
        1: '#ffffff',
        2: '#d5efed',
        3: '#fffef2',
      }
      return colorSet[this.mailData.color];
    },
  },
  methods: {
    submitMail() {
      this.mailData.name = this.removeEmojis(this.mailData.name);
      this.mailData.job = this.removeEmojis(this.mailData.job);
      this.mailData.body = this.removeEmojis(this.mailData.body);




      return null;



      // Add
      // fetch(window.location.protocol + '//newmedia.udn.com.tw/active_laravel/api/memory', {
      // // fetch(window.location.protocol + '//nmdap.udn.com.tw/newmedia/memory/api/memory', {
      // // fetch('https://newmedia.udn.com.tw/memory/api/memory', {
      // // fetch('api/memory', {
      //   method: 'post',
      //   body: JSON.stringify(this.mailData),
      //   headers: {
      //     'content-type': 'appication/json',
      //   },
      // })
      // .then((res) => res.json())
      // .then((data) => {
      //   this.mailData.name = '';
      //   this.mailData.job = '';
      //   this.mailData.body = '';
      // })
      // .then(() => {
      //   this.uploadingFlag = true;
      //   this.currentStep = 2; // 換紙鶴背景圖
      //   setTimeout(() => {
      //     // update Memory Gallery
      //     this.$root.$children[0].forceRerenderMemoryGallery();
      //     this.$root.$children[0].changeWriteMailFlag();
      //     this.$root.$children[0].changeCompletedFlag();
      //     this.$root.$children[0].changeFromWidgetFlag();
      //   }, 2000);
      // })
      // .catch(err => console.log(err));

      // window.ga('newmedia.send', {
      //   hitType: 'event',
      //   eventCategory: 'Button',
      //   eventAction: 'click',
      //   eventLabel: `[${Utils.detectPlatform()}] [Send]`,
      // });
    },
    selectColor(color) {
      this.mailData.color = color;
    },
    removeEmojis(string) {
      const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

      return string.replace(regex, '');
    },
    hintNecessaryItem() {
      // 檢查必填欄位
      if (this.mailData.name === '' && this.mailData.body === '') {
        this.hintMessage = '暱稱、我的921記憶欄位尚未填寫！';
        this.hintMessageFlag = true;
      } else if (this.mailData.name === '') {
        this.hintMessage = '暱稱欄位尚未填寫！';
        this.hintMessageFlag = true;
      } else if (this.mailData.body === '') {
        this.hintMessage = '我的921記憶欄位尚未填寫！';
        this.hintMessageFlag = true;
      } else {
        if (!this.hintMessageFlag) {
          this.calcWordLength(this.mailData.name, 'name');
        }
        if (!this.hintMessageFlag) {
          this.calcWordLength(this.mailData.job, 'job');
        } 
        if (this.nameWordLengthLegalFlag && this.jobWordLengthLegalFlag) {
          this.submitMessageFlag = true;
        }
      }
    },
    createBeforeUnloadHandler() {
      window.addEventListener('beforeunload', this.beforeUnloadHandler, false);
    },
    destroyBeforeUnloadHandler() {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler, false);
    },
    beforeUnloadHandler (e) {
      e = e || window.event
      if (e) {
        e.returnValue = '關閉提示';
      }
      return '關閉提示';
    },
    calcWordLength(str, item) {
      let count = str.replace(/[^\x00-\xff]/g,"**").length;
      if (item === 'name') {
        this.hintMessage = '暱稱字數超過限制！';
        this.hintMessageFlag = count > this.limitNameLength ? true : false;
        this.nameWordLengthLegalFlag = count > this.limitNameLength ? false : true;
      } 
      if (item === 'job') {
        this.hintMessage = '職業/身分字數超過限制！';
        this.hintMessageFlag = count > this.limitJobLength ? true : false;
        this.jobWordLengthLegalFlag = count > this.limitJobLength ? false : true;
      }
    },
  },
  destroyed() {
    this.destroyBeforeUnloadHandler();
  },
};
</script>

<style lang="scss" scoped>
  .write-panel-container {
    position: relative;
    display: flex;
    height: 100vh;
    padding-top: 50px;
    .cover-wrapper {
      position: relative;
      width: 40%;
      overflow: hidden;
      .cover-image {
        position: relative;
        width: 100%;
        height: 100%;
        background-position: left;
        background-size: cover;
      }
      .enter-in {
        animation-name: enterIn;
        animation-timing-function: ease-in-out;
        animation-duration: 2s;
      }
      @keyframes enterIn {
        0% {
          transform: scale(1.1);
        }
        100% {
          transform: scale(1);
        }
      }
      .leave-out {
        animation-name: leaveOut;
        animation-timing-function: ease-in-out;
        animation-duration: 2s;
      }
      @keyframes leaveOut {
        0% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.05);
        }
        100% {
          transform: scale(1);
        }
      }
    }
  }
  .write-panel-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    // display: flex;
    // flex-direction: column;
    padding: 10px;
    @media only screen and (min-width: 1024px) {
      width: 60%;
      padding: 3% 5%;
    }
    .write-panel {
      width: 100%;
      height: 85%;
      min-height: 400px;
      // display: flex;
      // flex-direction: column;
      // justify-content: flex-start;
      // align-items: flex-start;
      .input-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        margin: 5px 0;
        input {
          min-height: 24px;
          width: 100%;
          padding: 5px;
          border: none;
          outline: solid 1px rgba(#57b09f, 0.5);
        }
        input:focus {
          outline: solid 2px #57b09f;
        }
        ::placeholder {
          color: #57b09f;
          opacity: 0.7;
        }
        .textarea-wrapper {
          width: 100%;
          height: 100%;
          padding-bottom: 0;
          @media only screen and (min-width: 1024px) {
            padding-bottom: 50px;
          }
        }
        textarea {
          min-height: 230px;
          width: 100%;
          height: 100%;
          resize : none;
          padding: 5px;
          outline: solid 1px rgba(#57b09f, 0.5);
          border: none;
          transition: background-color .333s ease-in-out;
        }
        textarea:focus {
          outline: solid 2px #57b09f;
        }
      }
      .height-1 {
        height: 10%;
      }
      .height-2 {
        height: 80%;
      }
    }
    .color-selector-wrapper {
      position: relative;
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      color: #57b09f;
      font-size: 1rem;
      @media only screen and (min-width: 1024px) {
        justify-content: flex-end;
      }
      .color-selector {
        position: relative;
        box-sizing: content-box;
        width: 30px;
        height: 30px;
        border: solid 0.5px #9d9d9d;
        margin: 0 0 0 10px;
        cursor: pointer;
        transition: .333s ease-in-out;
        @media only screen and (min-width: 1024px) {
          width: 20px;
          height: 20px;
        }
      }
      .white {
        background-color: #ffffff;
      }
      .red {
        background-color: #d5efed;
      }
      .yellow {
        background-color: #fffef2;
      }
      .active {
        border: solid 3px #57b09f;
      }
    }
    .button-and-rights-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      margin: 12px 0;
      .submit-button-wrapper {
        .submit-button {
          background-color: #57b09f;
          border: none;
          color: white;
          padding: 15px 60px;
          text-decoration: none;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          cursor: pointer;
          img {
            width: 30px;
            margin: 0 5px;
          }
        }
        .disabled {
          box-shadow: none;
          border: none;
          background-color: #eeeeee;
        }
      }
      .rights-wrapper {
        padding: 50px 0 15px 0;
        color: #636363;
        font-size: 0.5rem;
        @media only screen and (min-width: 1024px) {
          padding: 30px 0 0 0;
        }
      }
    }
  }

  .hint-message-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .hint-message {
      position: relative;
      width: 500px;
      height: 250px;
      margin: 25px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px #57b09f;
      @media only screen and (min-width: 1024px) {
        height: 300px;
        margin: 0;
      }
    }
    .message-type-1 {
      background-color: #dedede;
      .hint-button-wrapper {
        position: absolute;
        bottom: 0;
        right: 0;
        margin: 10px;
        @media only screen and (min-width: 1024px) {
          margin: 20px;
        }
        .hint-button {
          padding: 10px 15px;
          border-radius: 2px;
        }
        .button-type-1 {
          border: solid 1px #707070;
          background-color: #6f6f6f;
          color: #ffffff;
        }
        .button-type-2 {
          border: solid 1px #707070;
          background-color: #dedede;
          color: #707070;
        }
      }
    }
    .message-type-2 {
      background-color: #ffffff;
      .hint-button-wrapper {
        position: relative;
        margin: 10px;
        @media only screen and (min-width: 1024px) {
          margin: 20px;
        }
        .hint-button {
          padding: 10px 15px;
          margin: 0 10px;
          border-radius: 2px;
        }
        .button-type-1 {
          border: solid 1px #707070;
          background-color: #6f6f6f;
          color: #ffffff;
        }
        .button-type-2 {
          border: solid 1px #707070;
          background-color: #dedede;
          color: #707070;
        }
      }
    }
  }

  .uploading-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 3%;
    @media only screen and (min-width: 1024px) {
      width: 60%;
      padding: 3% 5%;
    }
    img {
      width: 150px;
    }
    .uploading-bar-wrapper {
      position: relative;
      width: 250px;
      height: 6px;
      background-color: #f1f1f1;
      border: solid 0.2px #55B39D;
      .uploading-bar {
        height: 100%;
        background-color: #55B39D;
        animation-name: enlarge;
        animation-timing-function: ease-in-out;
        animation-duration: 1.5s;
      }
      @keyframes enlarge {
        0% {
          width: 0;
        }
        100% {
          width: 100%;
        }
      }
    }
    .uploading-text {
      padding: 10px;
      font-size: 1.3rem;
      color: #57b09f;
    }
  }
</style>
